
<template>
  <tr
      data-dusk="main-table-row"
      @click="handleEntireRowSelect"
      :style="[entireRowSelects ? {cursor: 'pointer'} : {}]"
  >
    <td v-if="hasSelect">
      <input
        v-if="singleSelect"
        type="radio"
        :checked="selectedValue"
        @change.stop.prevent="!entireRowSelects ? onSelect(row) : undefined"
        class="pr-xs"
      />
      <a-checkbox
          v-else
          :checked="selectedValue"
          @change.stop.prevent="!entireRowSelects ? onSelect(row) : undefined"
          class="pr-xs"
      ></a-checkbox>
    </td>
    <td
        class="cell"
        v-for="(header, idx) of headers"
        :key="idx"
        :style="{width: cellProps(header) && cellProps(header).width ? cellProps(header).width + 'px' : 'auto'}"
    >
      <component
          v-if="header.typeComponent"
          :is="header.typeComponent"
          :cellProps="cellProps(header)"
          :row="row"
          :style="{pointerEvents: entireRowSelects ? 'none' : 'auto'}"
      />
      <template v-else>
        {{ cellProps(header) }}
      </template>
    </td>
    <td v-if="this.$slots.actions" >
      <div class="flex-row justify-content-end">
        <slot name="actions"></slot>
      </div>
    </td>
  </tr>
</template>

<script>

export default {
  name: "DdTableRow",
  emits: ['toggle-row'],
  props: {
    selectedFromRow: {
      required: false,
      type: Boolean,
    },
    headers: {
      required: true,
      type: Array,
    },
    row: {
      required: true,
      type: Object,
    },
    selectedRows: {
      required: false,
      type: Array,
    },
    selectKey: {
      required: false, type: String,
    },
    hasSelect: {
      type: Boolean,
      required: false,
      default: false
    },
    entireRowSelects: {
      type: Boolean,
      required: false,
      default: false
    },
    singleSelect: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {
      hideActionButtons: true,
    }
  },
  methods: {
    onSelect(row) {
      this.$emit('toggle-row', row);
    },
    handleEntireRowSelect(e) {
      if ( this.entireRowSelects ) {
        this.onSelect(this.row);
        e.preventDefault();
        e.stopPropagation();
      }
    }
  },
  computed: {
    cellProps() {
      return (header) => {
        if (!('key' in header)) return undefined;
        if (typeof header.key === 'function') return header.key(this.row, header);
        if (header.key in this.row) return this.row[header.key];
      };
    },
    rowKeyValue()  {
      return this.row[this.selectKey]
    },
    selectedValue() {
      if (this.selectedFromRow) {
        return this.selectedRows.some((row) => row && row[this.selectKey] === this.rowKeyValue);
      }
      return this.selectedRows.includes(this.rowKeyValue);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.hide-buttons {
  opacity: 0;
}
</style>
